// extracted by mini-css-extract-plugin
export default {"claim_all":"all_claims_claim_all__MUQy9","btn_all_claims":"all_claims_btn_all_claims__KGSuI","loader":"all_claims_loader__sIBev","rotate":"all_claims_rotate__zDsPF"};